'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require('./Observer');

var _Observer3 = _interopRequireDefault(_Observer2);

var _Customer = require('./Customer');

var _Customer2 = _interopRequireDefault(_Customer);

var _Payment = require('./Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _Product = require('./Product');

var _Product2 = _interopRequireDefault(_Product);

var _TariffPoint = require('./TariffPoint');

var _TariffPoint2 = _interopRequireDefault(_TariffPoint);

var _Bonus = require('./Bonus');

var _Bonus2 = _interopRequireDefault(_Bonus);

var _Contract = require('./Contract');

var _Contract2 = _interopRequireDefault(_Contract);

var _ContractConnection = require('./ContractConnection');

var _ContractConnection2 = _interopRequireDefault(_ContractConnection);

var _ContractPrice = require('./ContractPrice');

var _ContractPrice2 = _interopRequireDefault(_ContractPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderContractModel = function (_Observer) {
    _inherits(OrderContractModel, _Observer);

    /**
     * Bonus für Ticketbestellung
     * @type {Bonus}
     */

    /**
     * CouponCode
     * @type {string}
     */

    /**
     * Soll ein Account erstellt werden?
     * @type {boolean}
     */

    /**
     * Liste von Geschwistern
     * @type {array}
     */

    /**
     * Tarifprodukt
     * @type {Product}
     */

    /**
     * Haltestelle von
     * @type {TariffPoint}
     */

    /**
     * Vertragsstart
     * @type {date}
     */

    /**
     * Rechnungsanschrift
     * @type {Customer}
     */

    /**
     * Inhaber des Bankkontos für Zahlweise
     * @type {Customer}
     */

    /**
     * War Bestellung erfolgreich?
     * @type {boolean}
     */
    function OrderContractModel(observers, id, request) {
        _classCallCheck(this, OrderContractModel);

        var _this = _possibleConstructorReturn(this, (OrderContractModel.__proto__ || Object.getPrototypeOf(OrderContractModel)).call(this, observers, id, request));

        _this.Success = false;

        _this.Customer = new _Customer2.default();
        _this.CustomerAccountOwner = new _Customer2.default();
        _this.CustomerLegalGuardian = new _Customer2.default();
        _this.CustomerPaymentOption = new _Payment2.default();
        _this.CustomerBillAddress = new _Customer2.default();

        _this.ContractStart = "";
        _this.ContractEnd = "";

        _this.TariffPointFrom = new _TariffPoint2.default();
        _this.TariffPointTo = new _TariffPoint2.default();
        _this.TariffProduct = new _Product2.default();

        _this.SchoolId = "";
        _this.SiblingChildren = [];
        _this.DeliveryToSchool = true;
        _this.CreateAccount = true;
        _this.ContractIdToChange = "";
        _this.CouponCode = "";
        _this.AdditionalUsers = [];
        _this.BonusOrder = new _Bonus2.default();

        _this.Response = {
            Contract: new _Contract2.default(),

            TicketCustomer: new _Customer2.default(),

            PaymentOptionCustomer: new _Payment2.default(),

            ContractConnection: new _ContractConnection2.default(),

            ContractPrice: new _ContractPrice2.default(),

            Share1: 0,
            Share2: 0,
            FlagLoss: true
        };
        return _this;
    }
    /**
     * Status extern
     * @type {string}
     */

    /**
     * Liste von Mitfahrer
     * @type {array}
     */

    /**
     * Id des zu ändernden Vertrages
     * @type {string}
     */

    /**
     * Soll das Ticket zu Schule geschickt werden?
     * @type {boolean}
     */

    /**
     * Id der Schule
     * @type {string}
     */

    /**
     * Haltestelle nach
     * @type {TariffPoint}
     */

    /**
     * Vertragsende
     * @type {date}
     */

    /**
     * Zahlweise
     * @type {Payment}
     */

    /**
     * Erziehungsberechtigte
     * @type {Customer}
     */

    /**
     * Kunde
     * @type {Customer}
     */


    _createClass(OrderContractModel, [{
        key: 'ContractsNrw',
        value: function ContractsNrw() {
            this.SetOrderNrw("ContractsNrw");
        }
    }, {
        key: 'Contracts',
        value: function Contracts(customerId, confirmationId, datefrom, dateto, identificationNumber, files) {
            this.SetOrder("ContractsWithConfirmations", customerId, confirmationId, datefrom, dateto, identificationNumber, files);
        }
    }, {
        key: 'SetOrderNrw',
        value: function SetOrderNrw(request) {
            var sendData = {};

            sendData.Customer = this.Customer;
            sendData.CustomerAccountOwner = this.CustomerAccountOwner;
            sendData.CustomerLegalGuardian = this.CustomerLegalGuardian;

            sendData.CustomerPaymentOption = this.CustomerPaymentOption;

            sendData.CustomerBillAddress = this.CustomerBillAddress;

            sendData.ContractStart = this.ContractStart;
            sendData.ContractEnd = this.ContractEnd;

            sendData.TariffPointFrom = this.TariffPointFrom;
            sendData.TariffPointTo = this.TariffPointTo;
            sendData.TariffProduct = this.TariffProduct;

            sendData.SchoolId = this.SchoolId;
            sendData.SiblingChildren = this.SiblingChildren;
            sendData.DeliveryToSchool = this.DeliveryToSchool;
            sendData.CreateAccount = this.CreateAccount;
            sendData.ContractIdToChange = this.ContractIdToChange;
            sendData.CouponCode = this.CouponCode;
            sendData.AdditionalUsers = this.AdditionalUsers;
            sendData.BonusOrder = this.BonusOrder;
            sendData.ExternalDescription = this.ExternalDescription;

            var me = this;

            this.request.setRequest("/" + request);
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                me.Success = true;
                if (result) {
                    if (result.Data) {
                        var resp = result.Data;
                        if (resp.Contract) {
                            me.Response.Contract = resp.Contract;
                        }
                        if (resp.TicketCustomer) {
                            me.Response.TicketCustomer = resp.TicketCustomer;
                            localStorage.setItem("CustomerId", resp.TicketCustomer.Id);
                        }
                        if (resp.PaymentOptionCustomer) {
                            me.Response.PaymentOptionCustomer = resp.PaymentOptionCustomer;
                        }
                        if (resp.ContractConnection) {
                            me.Response.ContractConnection = resp.ContractConnection;
                        }
                        if (resp.ContractPrice) {
                            me.Response.ContractPrice = resp.ContractPrice;
                        }
                        if (resp.Share1) {
                            me.Response.Share1 = resp.Share1;
                        }
                        if (resp.Share2) {
                            me.Response.Share2 = resp.Share2;
                        }
                        if (resp.FlagLoss !== null && resp.FlagLoss !== undefined) {
                            me.Response.FlagLoss = resp.FlagLoss;
                        }
                    }
                }

                var id = me.Id ? me.Id : request;
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'SetOrder',
        value: function SetOrder(request, customerId, confirmationId, datefrom, dateto, identificationNumber, files) {
            var sendData = {};

            sendData.Customer = this.Customer;
            sendData.CustomerAccountOwner = this.CustomerAccountOwner;
            sendData.CustomerLegalGuardian = this.CustomerLegalGuardian;

            sendData.CustomerPaymentOption = this.CustomerPaymentOption;

            sendData.CustomerBillAddress = this.CustomerBillAddress;

            sendData.ContractStart = this.ContractStart;
            sendData.ContractEnd = this.ContractEnd;

            sendData.TariffPointFrom = this.TariffPointFrom;
            sendData.TariffPointTo = this.TariffPointTo;
            sendData.TariffProduct = this.TariffProduct;

            sendData.SchoolId = this.SchoolId;
            sendData.SiblingChildren = this.SiblingChildren;
            sendData.DeliveryToSchool = this.DeliveryToSchool;
            sendData.CreateAccount = this.CreateAccount;
            sendData.ContractIdToChange = this.ContractIdToChange;
            sendData.CouponCode = this.CouponCode;
            sendData.AdditionalUsers = this.AdditionalUsers;
            sendData.BonusOrder = this.BonusOrder;
            sendData.ExternalDescription = this.ExternalDescription;

            var formData = new FormData();

            if (files != null) {

                for (var i = 0; i < files.length; i++) {

                    formData.append("file_" + i, files[i].file, files[i].file.Name);
                }
            }

            formData.append("customerId", customerId);

            formData.append("confirmationId", confirmationId);

            formData.append("datefrom", datefrom);

            formData.append("dateto", dateto);

            formData.append("identificationNumber", identificationNumber);

            formData.append("contract", JSON.stringify(sendData));

            var me = this;

            this.request.setRequest("/" + request);
            this.request.setContentType(false);
            this.request.setDataType(null);
            this.request.setProcessData(false);
            this.request.setData(formData);
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                me.Success = true;
                if (result) {
                    if (result.Data) {
                        var resp = result.Data;
                        if (resp.Contract) {
                            me.Response.Contract = resp.Contract;
                        }
                        if (resp.TicketCustomer) {
                            me.Response.TicketCustomer = resp.TicketCustomer;
                            localStorage.setItem("CustomerId", resp.TicketCustomer.Id);
                        }
                        if (resp.PaymentOptionCustomer) {
                            me.Response.PaymentOptionCustomer = resp.PaymentOptionCustomer;
                        }
                        if (resp.ContractConnection) {
                            me.Response.ContractConnection = resp.ContractConnection;
                        }
                        if (resp.ContractPrice) {
                            me.Response.ContractPrice = resp.ContractPrice;
                        }
                        if (resp.Share1) {
                            me.Response.Share1 = resp.Share1;
                        }
                        if (resp.Share2) {
                            me.Response.Share2 = resp.Share2;
                        }
                        if (resp.FlagLoss !== null && resp.FlagLoss !== undefined) {
                            me.Response.FlagLoss = resp.FlagLoss;
                        }
                    }
                }

                var id = me.Id ? me.Id : request;
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }]);

    return OrderContractModel;
}(_Observer3.default);

exports.default = OrderContractModel;